import {TweenMax, Power2} from 'gsap';

export class HomeSkills {

  public static element: HTMLElement;
  public static $element: JQuery<HTMLElement>;
  public static $links: JQuery<HTMLElement>;
  public static $img: JQuery<HTMLElement>;

  public static init() {

    HomeSkills.$element = $('.home-skills');
    HomeSkills.element = HomeSkills.$element.get(0);
    HomeSkills.$links = HomeSkills.$element.find('.home-skills-links li');
    HomeSkills.$img = HomeSkills.$element.find('.assembly-right');

    if (HomeSkills.$element.length) {
      HomeSkills.events();
    }
  }


  public static events() {

    HomeSkills.showSlide(0);

    HomeSkills.$links.on('mouseover', function (e) {
      e.preventDefault();
      let $this = $(this);
      let index = parseInt($this.attr('data-slide-to'));
      HomeSkills.showSlide(index);
    });

  }


  public static showSlide(index: Number) {

    let _this = this;

    let $slide = HomeSkills.$element.find('div[data-slide="' + index + '"]');

    if (TweenMax.isTweening(_this.$img)) {
      //return false;
    }

    TweenMax.set(HomeSkills.$img.not($slide), {zIndex: 0});
    TweenMax.set($slide, {zIndex: 1});

    TweenMax.set($slide, {
      autoAlpha: 1, onComplete: function () {
        TweenMax.set(HomeSkills.$img.not($slide), {autoAlpha: 0})
      }
    });

  }


}